export default __webpack_public_path__ + "b19217bea77f3556ef42bc771c97341c.png";